module.exports = __webpack_public_path__ + "static/developpement-et-creation-site-internet-f3141edee3436c61c6e10eaed2f82141.png";